import React, { createContext } from 'react';

export const BaseContainerContext = createContext();

export function mapContextToProps(Component, getPropsFromContext) {
  return props => (
    <BaseContainerContext.Consumer>
      { (context = {}) => <Component { ...props } { ...getPropsFromContext(context) } /> }
    </BaseContainerContext.Consumer>
  );
}
